<template lang="pug">
  header.header
    .header__head
      .container
        .row.header__row
          .header__head-left.col-2
            .language-switcher(:class="{ 'language-switcher_open': languageOpen }")
              button.language-switcher__trigger(type="button" :aria-expanded="languageOpen" @click="toggleLanguage")
                | {{ $t('layout.header.language') }}
                BaseIcon.language-switcher__chevron(name="chevron")
              Transition(name="fade")
                LocalSwitcher(v-if="languageOpen" @switch-locale="closeLanguage")

          .header__head-center.col-9
            .text {{ $t('layout.header.warning') }}
            RouterLink.header__head-center__link(:to="$i18nRoute({ name: 'NewsCard', params: { id: 4 } })")
              | {{ $t('learn_more') }}

    .header__body
      .container
        .row.header__row
          .header__body-left.col-4
            .header__info-text
              p Laboratories INFINITY MEDS
              p All Designed and formulated from Canada.

            .header__mobile
              button.header__mobile-burger(type="button" aria-label="Open menu" @click="uiStore.openMobileMenu")
                BaseIcon(name="burger")
              button.header__mobile-search(type="button" aria-label="Open search" @click="requestSearch")
                BaseIcon(name="search")

          .header__logo.col-4
            RouterLink.logo(:to="$i18nRoute({ name: 'Index' })")
              img(src="@/assets/images/logotype.png" alt="Infinity Meds" width="154" height="auto")

          .header__info.col-4
            .header__info-text
              p Laboratories INFINITY MEDS
              p All Designed and formulated from Canada.

            .header__mobile
              button.header__mobile-account(type="button" aria-label="Open account" @click="requestAccount")
                BaseIcon(name="account")
              .language-switcher
    .header__footer
      Transition(name="fade" mode="in-out")
        .header__footer-content(ref="menuElement" :class="{ 'header__footer_fixed': fixedMenu }")
          .container
            .row.header__row
              .col-12.header__menu
                ul.header__menu-list
                  li.header__menu-item
                    RouterLink(:to="$i18nRoute({ name: 'About' })") {{ $t('menu.about') }}
                  li.header__menu-item(v-if="categories.length")
                    span {{ $t('menu.products') }}
                    .header__menu-item__dropdown
                      ul.header__menu-list
                        li.header__menu-item(v-for="category in categories" :key="category.id")
                          RouterLink(
                            :to="$i18nRoute({ name: 'ProductsCategory', params: { category: category.name.toLowerCase() } })"
                          ) {{ capitalize(category.name) }}

                          ul.header__menu-list
                            li.header__menu-item(
                              v-for="manufacturer in category.manufacturers"
                              :key="manufacturer.id"
                            )
                              RouterLink(
                                :to="manufacturerRoute(category.name, manufacturer.name)"
                              ) {{ capitalize(manufacturer.name) }}
                  li.header__menu-item
                    RouterLink(:to="$i18nRoute({ name: 'News' })") {{ $t('menu.news') }}
                  li.header__menu-item
                    RouterLink(:to="$i18nRoute({ name: 'CheckCode' })") {{ $t('menu.check_code') }}
                  li.header__menu-item
                    RouterLink(:to="$i18nRoute({ name: 'Contact' })") {{ $t('menu.contact') }}
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { RouterLink, type RouteLocationRaw } from 'vue-router'
import BaseIcon from '@/components/common/BaseIcon.vue'
import LocalSwitcher from '@/components/LocalSwitcher.vue'
import { useCatalogStore } from '@/stores/catalog'
import { useUiStore } from '@/stores/ui'
import { capitalize } from '@/utils/formatters'
import { toSlug } from '@/utils/slug'
import { localizedRoute } from '@/composables/useLocalizedRoute'

const catalogStore = useCatalogStore()
const uiStore = useUiStore()
const { categories } = storeToRefs(catalogStore)
const fixedMenu = ref(false)
const languageOpen = ref(false)
const menuElement = ref<HTMLElement | null>(null)

const updateFixedMenu = (): void => {
  const menu = menuElement.value
  if (!menu) return
  fixedMenu.value = window.scrollY - menu.scrollHeight > menu.offsetTop + menu.scrollHeight
}

const toggleLanguage = (): void => {
  languageOpen.value = !languageOpen.value
}

const closeLanguage = (): void => {
  languageOpen.value = false
}

const manufacturerRoute = (categoryName: string, manufacturerName: string): RouteLocationRaw =>
  localizedRoute({
    name: 'ProductsCategoryManufacture',
    params: {
      category: categoryName.toLowerCase(),
      manufacture: toSlug(manufacturerName),
    },
  })

const requestSearch = (): void => window.dispatchEvent(new CustomEvent('infiniti:search-requested'))
const requestAccount = (): void => window.dispatchEvent(new CustomEvent('infiniti:account-requested'))

onMounted(() => {
  window.addEventListener('scroll', updateFixedMenu, { passive: true })
  updateFixedMenu()
})

onBeforeUnmount(() => window.removeEventListener('scroll', updateFixedMenu))
</script>
